import MultiSelectField from 'Components/Molecules/Fields/MultiSelectField/MultiSelectField';
import SelectField from 'Components/Molecules/Fields/SelectField/SelectField';
import AddressField from 'Components/Organisms/AddressField/AddressField';
import CombinationField from 'Components/Organisms/CombinationField/CombinationField';
import DateField from 'Components/Organisms/DateField/DateField';
import DropdownField from 'Components/Organisms/DropdownField/DropdownField';
import MultiSelectorField from 'Components/Organisms/MultiSelectorField/MultiSelectorField';
import RadioField from 'Components/Organisms/RadioField/RadioField';
import TextField from 'Components/Organisms/TextField/TextField';
import ToggleField from 'Components/Organisms/ToggleField/ToggleField';
import React from 'react';
import { connect } from 'react-redux';
import { FieldRequired, FieldType } from 'Store/FieldManagement/PropTypes';
import NumberField from '../../../../../../Components/Molecules/NumberField/NumberField';
import HTMLField from './HTMLField';

interface FieldProps {
    isEdit?: boolean,
    value: any,
    type: FieldType,
    required?: FieldRequired,
    onChange?: (value: any) => any
    isInline?: boolean
    alignLeft?: boolean
    placeholder?: string
    fieldProperties?: any
}

const Field = ({isEdit = false, value: defaultValue, type, required, onChange, fieldProperties, isInline, alignLeft, placeholder}: FieldProps) => {
    const handleChange = (value: any) => {
        if (!isEdit) return;

        if (onChange) onChange(value);
    }

    return <>
        { type === FieldType.Text &&
            <TextField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
                placeholder={placeholder || 'Typ hier een waarde...'}
            />
        }
        { type === FieldType.Number &&
            <NumberField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
            />
        }
        { type === FieldType.Date &&
            <DateField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
            />
        }
        { type === FieldType.Dropdown &&
            <DropdownField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
                fieldProperties={{
                    ...fieldProperties,
                    isInline: isInline,
                    alignLeft: fieldProperties?.alignLeft || alignLeft,
                    dataset: fieldProperties,
                }}
            />
        }
        { type === FieldType.Multi_Selector &&
            <MultiSelectorField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
                fieldProperties={{
                    ...fieldProperties,
                    isInline: isInline,
                    alignLeft: fieldProperties?.alignLeft || alignLeft,
                    dataset: fieldProperties
                }}
            />
        }

        { type === FieldType.HTML_Editor &&
            <HTMLField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
                fieldProperties={{
                    ...fieldProperties,
                    isInline: isInline,
                    alignLeft: alignLeft
                }}
            />
        }
        { type === FieldType.Toggle &&
            <ToggleField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
            />
        }
        { type === FieldType.Address &&
            <AddressField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
                fieldProperties={{
                    isInline: isInline
                }}
            />
        }
        { type === FieldType.Combination &&
            <CombinationField
                isEdit={isEdit}
                value={defaultValue}
                onChange={handleChange}
                fieldProperties={fieldProperties}
            />
        }
        { type === FieldType.Select &&
            <>
                <SelectField
                    isEdit={isEdit}
                    value={defaultValue}
                    onChange={handleChange}
                    fieldProperties={fieldProperties}
                />
                { isEdit && fieldProperties?.helper && <small>{ fieldProperties?.helper }*</small> }
            </>
        }
        { type === FieldType.MultiSelect &&
            <>
                <MultiSelectField
                    isEdit={isEdit}
                    value={defaultValue}
                    onChange={handleChange}
                    fieldProperties={fieldProperties}
                />
                { isEdit && fieldProperties?.helper && <small>{ fieldProperties?.helper }*</small> }
            </>
        }
        { type === FieldType.Radio &&
            <>
                <RadioField
                    isEdit={isEdit}
                    value={defaultValue}
                    onChange={handleChange}
                    fieldProperties={fieldProperties}
                />
            </>
        }
    </>;
}


export default React.memo(Field);